import { getPopularSearches, getRecentSearches } from '../Shared/scriptts/rootcomponents/autocomplete';
import { AutocompleteResult } from '../Shared/scriptts/interfaces';
import { getUsajConfig, getUserObject } from '../Shared/scriptts/session/sessionmain';

export async function displayRecentSearches() {
    const config = getUsajConfig();
    const dataHome = config.DataHome || '';
    const searchesSection = document.querySelector<HTMLElement>('#searches-section');
    const searchesList = document.querySelector<HTMLElement>('#searches-list');

    if (!searchesSection || !searchesList) {
        return;
    }

    const recentResults = getRecentSearches('keyword');
    const recentSearches = recentResults?.Recent || [];
    const searchesToDisplay: AutocompleteResult[] = [];

    if (recentSearches.length >= 2) {
        searchesToDisplay.push(recentSearches[0], recentSearches[1]);
    } else if (recentSearches.length < 2) {
        let popularSearches: AutocompleteResult[] = [];
        try {
            const popularSearchesData = await getPopularSearches('keyword', dataHome);
            if (popularSearchesData?.popular) {
                popularSearches = popularSearchesData.popular.map(search => ({
                    ...search,
                    Type: 'keyword'
                }));
            }
        } catch (error) {
            console.error('Error fetching popular searches:', error);
        }

        if (recentSearches.length === 0) {
            searchesToDisplay.push(...popularSearches.slice(0, 2));
        } else {
            searchesToDisplay.push(recentSearches[0]);

            if (popularSearches.length > 0) {
                const recentName = recentSearches[0].Name.toLowerCase().trim();
                const popularIndex = popularSearches[0].Name.toLowerCase().trim() === recentName && popularSearches.length > 1 ? 1 : 0;

                if (popularIndex < popularSearches.length) {
                    searchesToDisplay.push(popularSearches[popularIndex]);
                }
            }
        }
    }

    if (searchesToDisplay.length === 0) {
        searchesSection.classList.add('hidden');
        return;
    }

    searchesList.innerHTML = '';
    searchesToDisplay.forEach(search => {
        searchesList.appendChild(createSearchPill(search.Name));
    });
    searchesSection.classList.remove('hidden');
}

function createSearchPill(name: string): HTMLAnchorElement {
    const pill = document.createElement('a');
    pill.href = `/Search/Results?${new URLSearchParams({ k: name }).toString()}`;
    pill.className = 'button button-primary inline-flex items-center justify-center gap-x-1 mr-0';

    pill.innerHTML = `
        <svg class="w-4 h-4 fill-white" role="presentation">
            <use href="/img/icons/sprite.svg#search"></use>
        </svg>
    `;

    const label = document.createElement('span');
    label.textContent = name;

    pill.appendChild(label);

    return pill;
}

function toggleHiringPathBlankSearchOptions() {
    const preferencesSection = document.querySelector<HTMLElement>('#search-preferences-section');
    const currentFedsButton = document.querySelector<HTMLElement>('#search-option-current-feds');
    const publicButton = document.querySelector<HTMLElement>('#search-option-public');

    if (!preferencesSection || !currentFedsButton || !publicButton) {
        return;
    }

    const currentFedCode = preferencesSection.getAttribute('data-current-fed-code');
    const userObject = getUserObject();

    if (!userObject.IsAuthenticated || !currentFedCode) {
        return;
    }

    const isCurrentFed = userObject.FederalCode === currentFedCode;

    currentFedsButton.classList.toggle('hidden', !isCurrentFed);
    publicButton.classList.toggle('hidden', isCurrentFed);
}

export async function displaySearchOptions() {
    const preferencesSection = document.querySelector<HTMLElement>('#search-preferences-section');

    if (!preferencesSection) {
        return;
    }

    toggleHiringPathBlankSearchOptions();
    await displayRecentSearches();

    preferencesSection.classList.remove('hidden');
}
